import React from 'react';
import { Figure, Photo } from './Styled';

export interface ICardProps {
    photo: string;
    children: React.ReactChild;
}

const Card = (props: ICardProps) => (
    <React.Fragment>
        <Figure>
            <Photo src={props.photo} className="photo" />
        </Figure>
        <div style={{ padding: '6.75% 13.5% 13.5%' }}>{props.children}</div>
    </React.Fragment>
);

export default Card;
